export default "__VITE_ASSET__BRljYh6V__"